/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { Grid, Typography, Box, Stack } from '@mui/material';
import { ENVIRONMENT } from 'config';

const chunk = (arr, size = 2) =>
  arr.reduce((acc, _, i) => {
    if (i % size === 0) {
      acc.push({
        id: `set-${acc.length + 1}`,
        items: arr.slice(i, i + size),
      });
    }
    return acc;
  }, []);

const TabularFilterHeader = ({
  title,
  hotelName,
  comparisonHotelName,
  sections,
  chunkSize = 2,
  interpreterFragment = null,
}) => {
  const pairedSections = chunk(sections, chunkSize);
  return (
    <Box py={1} width="100%" mb={1}>
      <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
        <Typography fontWeight={600}> {title}</Typography>
        {ENVIRONMENT.IS_VISUAL_INTERPRETER_ENABLED?.toLowerCase() === 'true' && (
          <Grid item mt={1} mr={4}>
            {interpreterFragment}
          </Grid>
        )}
      </Stack>
      <Typography fontWeight="bold" mt={1}>
        {comparisonHotelName ? (
          <>
            Selection Hotel (A):{' '}
            <Box component="span" fontWeight="bold">
              {hotelName}
            </Box>{' '}
            <br />
            Comparison Hotel Set (B):{' '}
            <Box component="span" fontWeight="bold">
              {comparisonHotelName}
            </Box>
          </>
        ) : (
          <>
            Hotel :{' '}
            <Box component="span" fontWeight="bold">
              {hotelName}
            </Box>
          </>
        )}
      </Typography>
      {chunkSize === 1 ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            flexDirection: 'row',
          }}
        >
          {pairedSections.map((set) =>
            set.items.map((section) => (
              <Typography variant="body2" key={section.id} mt={2}>
                {section.title}: {section.value}
              </Typography>
            ))
          )}
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            width: '100%',
            columnGap: 2,
            mt: 1,
          }}
        >
          {pairedSections.map((set) => (
            <Box key={set.id} sx={{ flexBasis: { xs: '100%', sm: 'auto' } }}>
              {set.items.map((section) => (
                <Typography
                  variant="body2"
                  key={section.id}
                  mt={2}
                  sx={{ fontSize: { xs: 8, sm: 9, md: 9.8, lg: 10.5, xl: 12 } }}
                >
                  {section.title}: {section.value}
                </Typography>
              ))}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default TabularFilterHeader;
